export enum PersonType {
  Operator = 0,
  Visitor = 1,
  System = 4,
  OperatorTranslated = 7,
  VisitorTranslated = 8
}
